'use strict';

var handleDeepProperty = require('./handleDeepProperty');

function deepHasProperty(obj, key, any) {
  return handleDeepProperty(obj, key, any, true);
}

module.exports = deepHasProperty;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/deepHasProperty.js
// module id = 439
// module chunks = 0